import { render, staticRenderFns } from "./ObjectPageHeaderMobile.vue?vue&type=template&id=5c83c980"
import script from "./ObjectPageHeaderMobile.vue?vue&type=script&lang=js"
export * from "./ObjectPageHeaderMobile.vue?vue&type=script&lang=js"
import style0 from "./ObjectPageHeaderMobile.vue?vue&type=style&index=0&id=5c83c980&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports